import { useSelector } from 'react-redux';
import { selectUserLoop } from 'services/store/remixer/selectors';
import FileInfoContainer from './components/FileInfoContainer';
import UserLoopBox from './components/UserLoopBox';

export const UserLoop = () => {
  const userLoop = useSelector(selectUserLoop);

  if (userLoop) {
    return <FileInfoContainer />;
  }

  return <UserLoopBox />;
};

export default UserLoop;
